<template>
  <div class="l-content-inner">
    <!-- 회원가입 -->
    <div class="p-member-wrap">
      <!-- D: 2024-12-30 c-hgroup 클래스에 is-pc 클래스추가 -->
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">노루페인트 PAINT PRO 비밀번호 찾기</h1>
      </div>

      <form action="">
        <div class="form-wrap type-large-gap">
          <div class="c-form-field">
            <label
              class="c-input-label-group"
              :class="{ 'is-danger': isNvl('custCd') }"
            >
              <input
                type="text"
                required
                title="아이디"
                maxlength="10"
                v-model="form.custCd"
                @keyup="() => (touched.custCd = true)"
                @blur="() => (touched.custCd = true)"
              />
              <span class="input-label">아이디</span>
              <span v-show="isEmpty('busiNo')" class="input-helper">
                아이디를 입력해주세요.
              </span>
            </label>
          </div>

          <div class="c-form-field">
            <label
              class="c-input-label-group"
              :class="{ 'is-danger': isNvl('email') }"
            >
              <input
                type="text"
                required
                title="이메일"
                maxlength="100"
                v-model="form.email"
                @keyup="() => (touched.email = true)"
                @blur="() => (touched.email = true)"
              />
              <span class="input-label">이메일</span>
              <!-- D: 유효성 문구 -->
              <span v-show="isEmpty('email')" class="input-helper">
                이메일을 입력해주세요.
              </span>
              <span v-show="isInvalidEmail()" class="input-helper">
                올바른 이메일 형식을 입력해 주세요. 예)noroo@noroo.com
              </span>
              <span v-show="isInvalidEmail()" class="input-result">
                사용불가
              </span>
              <span class="input-helper"
                >회원정보에 등록된 이메일을 입력해주세요</span
              >
              <button
                type="button"
                class="c-btn-icon btn-small-delete"
                @click.prevent="() => (form.email = '')"
              >
                <span class="c-icon icon-small-x"></span>
              </button>
            </label>
          </div>
        </div>

        <div class="c-btn-area">
          <button
            type="button"
            class="c-button type-primary"
            :disabled="submitDisabledYn"
            @click.prevent="submit"
          >
            <span>확인</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, defineEmits, inject } from "vue";
import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";

const emits = defineEmits(["next"]);
const url = inject("url_prefix");

const form = ref({
  custCd: "", // 아이디
  email: "", // 이메일
});

const touched = ref({
  custCd: false, // 아이디
  email: false, // 이메일
});

/**********************
 * 마운트
 *********************/
 onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  loadRememberUserId();
}

const loadRememberUserId = () => {
  const rememberedId = localStorage.getItem("REMEMBER_USER_ID");
  if (Utils.isNotBlank(rememberedId)) {
    form.value.custCd = rememberedId;
  }
};

const submitDisabledYn = computed(() => {
  return (
    !touched.value.custCd ||
    !touched.value.email ||
    isNvl("custCd") ||
    isNvl("email")
  );
});

const isInvalidEmail = () => {
  return (
    !Utils.isBlank(form.value.email) && !Utils.isValidEmail(form.value.email)
  );
};

const isNvl = (field) => {
  return touched.value[field] && isInvalid(field);
};

const isInvalid = (field) => {
  if (field === "email") {
    return Utils.isBlank(form.value[field]) || isInvalidEmail();
  }

  return Utils.isBlank(form.value[field]);
};

const isEmpty = (field) => {
  return touched.value[field] && Utils.isBlank(form.value[field]);
};

const submit = async () => {
  const payload = {
    custCd: form.value.custCd,
    email: form.value.email,
  };

  const res = await api.post(`${url}/register/pwd-search`, payload);

  // if (res.resultCode !== 200 || res.resultCode !== 202) {
  //   cmUtil.alert(res.message);
  //   return;
  // }

  if (res.error) {
    if (res.error.status === "404") {
      cmUtil.alert("일치하는 정보가 업습니다. <br/>문의: 담당 영업사원");
    } else {
      cmUtil.alert("오류가 발생하였습니다. <br/>문의: 담당 영업사원");
    }

    return;
  }
  emits("next", res.data);
};
</script>
